import Domen from "../../../stores/Domen";

export async function GetDataDeployPreview(setDeployprew) {
    const token = localStorage.getItem("token");
    localStorage.setItem("countactivetime", Date.now());

    const response = await fetch(Domen.url + `portraits/table/deploy/preview`, {
        method: 'GET',
        headers: {
            'Authorization': token,
            'Content-Type': 'application/json',
        }
    });

    if (response.status === 200) {
        const data = await response.json();
        setDeployprew(data);
    }
}
